import ('~style/templates/single-event/_single-event.scss');
import ('~style/blocks/events/_event-clocks.scss');
import ('~style/blocks/events/_base-timer.scss');
import { add_parallax_to_image } from "~scripts/utility/parallax";

// Workaround to make parallax effect working in Safari browsers
if ( document.querySelector('html').classList.contains('safari') ) {
  // Pushes header to the top to avoid a white gap cause by the navbar pushing the header down
  const navBarHeight = document.querySelector('.navbar').getBoundingClientRect().height;
  document.querySelectorAll('.js-header-bg-image').style.marginTop = -navBarHeight + 'px';

  // Applies parallax effect
  add_parallax_to_image( document.querySelector('.js-header-bg-image') );
}
